import { EMPTY_OBJECT } from 'commons-ui';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT } = params;

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/tournament/edit',
					state: {
						rowData
					}
				});
			};
		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/tournament/create'
				});
			};

		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
